"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Textarea = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const Textarea = ({ value, onChange, id, error, placeholder, disabled, fullHeight, maxLength = 800, rows, }) => {
    return (react_1.default.createElement("textarea", { className: (0, classnames_1.default)('w-full resize-none rounded border px-2 py-2 focus:outline-none focus:ring focus:ring-blue-4/40', error ? 'border-red-5' : 'border-grey-3 focus:border-blue-4', fullHeight ? 'h-full' : 'h-56'), value: value, onChange: (e) => onChange(e.currentTarget.value, e), id: id, placeholder: placeholder, disabled: disabled, maxLength: maxLength, rows: rows }));
};
exports.Textarea = Textarea;
